import { Container } from 'react-bootstrap'
import styled from 'styled-components'

export const NoContentWrapper = styled(Container)<{ disableImageFilter?: boolean }>`
  img {
    ${({ disableImageFilter }) => !disableImageFilter && `
      filter: brightness(0) saturate(100%) invert(77%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(85%);
      -webkit-filter: brightness(0) saturate(100%) invert(77%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(85%);
    `}
  }
`

export const NoContentText = styled.h6`
  font-weight: 600;
  color: var(--bs-grey-dark);
  margin: 0;
  line-height: 24px;
`
